import { Avatar, Grid } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomInput from '../../CustomInput'
import S3 from 'react-aws-s3'
import { config } from '../../../utils/uploadImage'
import { Camera } from '@material-ui/icons'
import Loader from '../../Loader'
// import CustomSelect from '../../CustomSelect'
import { useCustomerType } from '../../../hooks/CompanyConfiguration/useCustomerType'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { EmployeeContext } from '../../../context api/Employee/EmployeeContext'
import { useCompanyAdmin } from '../../../hooks/CompanyAdmin/useCompanyAdmin'
import { sortByName } from '../../../shared/constants'
import { CustomSelect } from '../../CustomForm'
import useValidation from '../../../hooks/Validation/useValidation'
import SwitchStatus from '../../SwitchStatus'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'

export default function CustomerForm({ form, setForm }) {
  const [progress, setProgress] = React.useState(false)
  const { getAllCustomerType } = useCustomerType()
  const { customerTypes } = useContext(ConfigurationContext)
  const { employees } = useContext(EmployeeContext)
  const { getAllEmployee } = useCompanyAdmin()

  useEffect(() => {
    getAllCustomerType()
    getAllEmployee()
  }, [])

  const { name, leadSource, designation, phoneNumber, email, state, city, pincode, address, siteAddress, gstNumber, profilePicture, customerType, addedBy, countryCode } = form

  const filteredEmployee = employees && employees.filter((item) => item.rank === 6)

  const [imagePreview, setImagePreview] = useState(profilePicture)
  const { error, handleValidation } = useValidation()
  //console.log('ERRO : ', error)
  //console.log('IMAGE : ', profilePicture)
  const handleFile = (e) => {
    setProgress(true)

    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader()
      reader.onload = (e) => {
        setImagePreview(e.target.result)
        // setImageUploaded(true)
      }
      reader.readAsDataURL(e.target.files[0])
      const ReactS3Client = new S3(config)
      ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}${e.target.files[0].name}`)
        .then((data) => {
          setForm({ ...form, profilePicture: data.location })
          //console.log(data.location)
          setProgress(false)
        })
        .catch((err) => {
          //console.log(err)
          setProgress(false)
        })
    }
  }

  const inputField = [
    { label: 'Salutation', value: form.salutation, name: 'salutation', options: ['Mr.', 'Mrs.', 'Miss'] },
    { label: 'Name', value: name, name: 'name' },
    {
      label: 'Customer Type',
      value: customerType,
      name: 'customerType',
      select: true,
      options: sortByName(customerTypes),
      fieldName: 'name',
      fieldValue: '_id',
    },
    // { label: 'Lead Source', value: leadSource, name: 'leadSource', select: true },
    { label: 'Designation', value: designation, name: 'designation', noValidate: true },
    {
      value: countryCode,
      name: 'countryCode',
      type: "COUNTRYCODE",
    },
    {
      label: 'Phone Number',
      value: phoneNumber,
      name: 'phoneNumber',
    },
    { label: 'Email', value: email, name: 'email', conditions: [{ type: 'EMAIL' }] },
    {
      label: 'State',
      value: state,
      name: 'state',
    },
    {
      label: 'City',
      value: city,
      name: 'city',
    },
    {
      label: 'Pincode',
      value: pincode,
      name: 'pincode',
    },
    {
      label: 'Resident Address',
      value: address,
      name: 'address',
    },
    {
      label: 'Site Address',
      value: siteAddress,
      name: 'siteAddress',
    },
    { label: 'GST Number', value: gstNumber, name: 'gstNumber', noValidate: true },
    {
      label: 'Assign Employee',
      value: addedBy,
      name: 'addedBy',
      select: true,
      options: sortByName(filteredEmployee, 'firstName'),
      fieldName: 'firstName',
      fieldValue: '_id',
    },
  ]

  return (
    // <Grid container spacing={3}>
    //   <Grid item lg={4}>
    //     <div
    //       style={{
    //         paddingLeft: '45px',
    //         // paddingTop: '10px',
    //         paddingBottom: '5px',
    //         display: 'flex',
    //         alignItems: 'center',
    //       }}
    //     >
    //       <input
    //         accept="image/*"
    //         style={{ display: 'none' }}
    //         id="contained-button-file"
    //         type="file"
    //         onChange={handleFile}
    //       />
    //       {imagePreview || profilePicture ? (
    //         <Avatar src={profilePicture} style={{ width: '70px', height: '70px', marginRight: '10px' }} />
    //       ) : (
    //         <Avatar style={{ width: '70px', height: '70px', marginRight: '10px' }} />
    //       )}
    //       <label htmlFor="contained-button-file">
    //         <Camera style={{ cursor: 'pointer' }} />
    //       </label>
    //       {progress ? (
    //         <Loader />
    //       ) : // <label htmlFor="contained-button-file">
    //       //   <Camera style={{ cursor: 'pointer' }} />
    //       // </label>
    //       null}
    //     </div>
    //   </Grid>
    //   {inputField.map((item, index) => (
    //     <Grid item lg={4} key={index}>
    //       {item.select ? (
    //         <CustomSelect
    //           label={item.label}
    //           button={item.button}
    //           options={item.options}
    //           value={item.value}
    //           // handleChange={item.handleChange}
    //           form={form}
    //           setForm={setForm}
    //           formCheck={true}
    //           name={item.name}
    //           disabled={item.disabled}
    //           fieldName={item.fieldName}
    //           fieldValue={item.fieldValue}
    //           errorMessage={error && item.error}
    //           onKeyDown={() => handleValidation(item.name, item.value)}
    //         />
    //       ) : (
    //         <CustomInput
    //           label={item.label}
    //           icon={item.icon}
    //           name={item.name}
    //           value={item.value}
    //           number={item.number ? true : false}
    //           form={form}
    //           setForm={setForm}
    //           formCheck={true}
    //           type={item.type}
    //           errorMessage={error && item.error}
    //           onKeyDown={() => handleValidation(item.name, item.value)}
    //         />
    //       )}
    //     </Grid>
    //   ))}
    //   {/* {category && <img src={category && category[0].image} width="100px" />} */}
    //   <SwitchStatus form={form} setForm={setForm} value={form.active} />
    // </Grid>

    <CustomAddForm state={form} setState={setForm} data={inputField} />
  )
}
